import {
  Divider,
  Link,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useContentData } from "./layout";
import { LanguageCode } from "types";
import axios from "axios";
import { GET_SIGNED_URL } from "config";
import { useState, useEffect } from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DownloadIcon from "@mui/icons-material/Download";

const Transcript = () => {
  console.log("Transcript");
  const { id, language } = useParams();
  const { content } = useContentData();

  const translationData =
    content.translatedLanguages[language! as LanguageCode];

  const transcriptUrl = translationData?.target_transcript;
  const title = translationData?.title || content.title;

  const [transcript, setTranscript] = useState<string>();

  useEffect(() => {
    const getTranscript = async () => {
      try {
        console.log("get transcript start ", transcriptUrl);
        const signedUrlResponse = await axios.post(GET_SIGNED_URL, {
          contentUrl: transcriptUrl,
        });
        const signedUrl = await signedUrlResponse.data.url;
        const transcriptResponse = await axios.get(signedUrl);
        // const temp = await transcriptResponse.data
        // console.log("get transcript end ", temp)
        setTranscript(await transcriptResponse.data);
      } catch (error) {
        console.error("Error fetching transcript:", error);
      }
    };

    getTranscript();
  }, []);

  const downloadFile = (text: string) => {
    const element = document.createElement("a");
    const file = new Blob([text], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "transcript.txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  return (
    <Stack>
      <Link
        component={RouterLink}
        to={`/content/${id}/${language}`}
        sx={{ textDecoration: "none" }}
      >
        <Stack
          direction="row"
          sx={{ bgcolor: "secondary.light", py: 2, pl: 6 }}
        >
          <ArrowBackIcon />{" "}
          <Typography
            sx={{
              fontWeight: 700,
            }}
          >
            Back to Content
          </Typography>
        </Stack>
      </Link>

      <Stack
        direction="row"
        spacing={5}
        sx={{ justifyContent: "space-between", width: "100%", pl: 8, pr: 5 }}
      >
        <Stack>
          <Typography variant="h4" sx={{ py: 4 }}>
            {title}
          </Typography>
          <Typography sx={{ color: "black" }}>{transcript}</Typography>
        </Stack>
        <Stack sx={{ minWidth: 255 }}>
          <Typography
            variant="body1"
            sx={{ py: 3, textTransform: "uppercase", fontWeight: 500 }}
          >
            Actions
          </Typography>
          <List>
            <ListItemButton
              onClick={() => {
                if (transcript) {
                  downloadFile(transcript);
                }
              }}
              disableGutters
            >
              <ListItemIcon>
                <DownloadIcon
                  fontSize="large"
                  sx={{
                    color: "primary.main",
                    bgcolor: "secondary.main",
                    borderWidth: 6,
                    borderStyle: "solid",
                    borderColor: "secondary.main",
                    borderRadius: 2,
                  }}
                />
              </ListItemIcon>

              <ListItemText primary="Download Transcript" />
              <ChevronRightIcon />
            </ListItemButton>
            <Divider />
          </List>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Transcript;
